import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'fileExtension',
  standalone: true
})
export class FileExtensionPipe implements PipeTransform {
  transform(path?: string | null): string {
    return path ? path.split('.', -1)[1] : ''
  }
}
